// extracted by mini-css-extract-plugin
module.exports = {"richText":"styles-module--richText--w5oZz","fadeIn":"styles-module--fadeIn--vz9n5","pulse":"styles-module--pulse--1ogPZ","slideInDown":"styles-module--slideInDown--33T2k"};